"use strict";
/**
 * @description: 类型相关工具类
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.forceGetTypeValue = exports.stringifyJson = exports.parseJson = exports.dateToDateString = void 0;
/**
 * @param {string} numStr
 * @param {number} length
 * @return {string}
 */
function paddingZero(numStr, length) {
    var result = undefined;
    if (length > numStr.length) {
        result = new Array(length - numStr.length + 1).join('0') + numStr;
    }
    else {
        result = numStr;
    }
    return result;
}
/**
 * @description 转日期字符串
 * @param {Date} date
 * @return {string}
 */
function dateToDateString(date) {
    return (date.getFullYear().toString() +
        paddingZero((date.getMonth() + 1).toString(), 2) +
        paddingZero(date.getDate().toString(), 2));
}
exports.dateToDateString = dateToDateString;
/**
 * @description 转换json字符串为json对象
 * @param {string} jsonString json字符串
 * @return {any} json对象或null
 */
function parseJson(jsonString) {
    var result = null;
    try {
        result = JSON.parse(jsonString);
    }
    catch (error) {
        console.error(error);
        result = null;
    }
    return result;
}
exports.parseJson = parseJson;
/**
 * @description 转换json对象为json字符串
 * @param {any} jsonObject json对象
 * @return {string} json字符串
 */
function stringifyJson(jsonObject) {
    var result = undefined;
    try {
        result = JSON.stringify(jsonObject);
    }
    catch (error) {
        console.error(error);
        result = undefined;
    }
    return result;
}
exports.stringifyJson = stringifyJson;
/**
 * @description 强制获取指定类型的值，如果value的类型与type不对应，则返回默认值，否则返回value值
 * @param {string} type 类型
 * @param {any} value 值
 * @param {T} defaultValue 默认值
 * @return {T}
 */
function forceGetTypeValue(type, value, defaultValue) {
    if (typeof value === type) {
        return value;
    }
    else {
        return defaultValue;
    }
}
exports.forceGetTypeValue = forceGetTypeValue;
//# sourceMappingURL=type.js.map